export class VarNum {

  public static FromObj(obj: any): VarNum {
    const v = new VarNum(0);
    v.mode = obj.mode as InputMode;
    v.v0 = obj.v0;
    v.v1 = obj.v1;
    return v;
  }
  public mode: InputMode = InputMode.Constant;

  public v0: number = 0;
  public v1: number = 0;
  public rampStart: number = 2;
  public rampLength: number = 3;

  constructor(constVal: number) {
    this.v0 = constVal;
    this.v1 = constVal;
  }

  public Value(time: number): number {
    if (this.mode === InputMode.Constant) {
      return this.v0;
    } else if (this.mode === InputMode.StepRamp) {
      if (time <= this.rampStart) {
        return this.v0;
      } else if (time >= this.rampStart + this.rampLength) {
        return this.v1;
      } else {
        const t = (time - this.rampStart) / this.rampLength;
        return this.v0 + (this.v1 - this.v0) * t;
      }
    } else {
      return Number.NaN;
    }
  }
}

export enum InputMode {
  Constant = 0,
  StepRamp = 1,
}
